export const FETCH_DEPARTMENTS = "FETCH_DEPARTMENTS";
